<template>
  <b-container fluid>
    <b-overlay :show="load" rounded="sm">

    <!-- Service Type: Kinds -->
    <b-row>
      <b-col xs="12" sm="12" md="12" class="text-center">
          <b-button variant="primary" @click="pdfExport">
              {{  $t('globalTrans.export_pdf') }}
          </b-button>
      </b-col>

      <!-- iq-card -->
      <b-col xs="12" sm="12" md="12" lg="12" xl="12">
        <iq-card>
          <template v-slot:body>

            <!-- Hospital Info -->
            <template>
              <div style="font-size:18px; background-color: #2D7446;" align="center">
                <h5 class="text-white">
                  {{ $t('hospital_configuration.hospital_info') }}
                </h5>
              </div>
            </template>

            <!-- b-table -->
            <b-table-simple bordered>
              <b-tr>
                <b-th>{{ $t('hospital_configuration.hospital_name_en') }}</b-th>
                <b-td>{{ hospital.text_en }}</b-td>
                <b-th>{{ $t('hospital_configuration.hospital_name_bn') }}</b-th>
                <b-td>{{ hospital.text_bn }}</b-td>
              </b-tr>

              <b-tr>
                <b-th>{{ $t('hospital_configuration.hospital_category') }}</b-th>
                <b-td>{{ hospital.category_text }}</b-td>
                <b-th>{{ $t('org_pro.area_type') }}</b-th>
                <b-td>{{ hospital.area_type_text }}</b-td>
              </b-tr>

              <b-tr>
                <b-th>{{ $t('globalTrans.division') }}</b-th>
                <b-td>{{ hospital.division_text }}</b-td>
                <b-th>{{ $t('globalTrans.district') }}</b-th>
                <b-td>{{ hospital.district_text }}</b-td>
              </b-tr>

              <b-tr>
                <b-th v-if="areaTypeId === 1">{{ $t('org_pro.city_corporation') }}</b-th>
                <b-td v-if="areaTypeId === 1">{{ hospital.city_corporation_text }}</b-td>

                <b-th v-if="areaTypeId >= 2">{{ $t('org_pro_upazilla.upazilla') }}</b-th>
                <b-td v-if="areaTypeId >= 2">{{ hospital.upazilla_text }}</b-td>

                <b-th v-if="areaTypeId === 2">{{ $t('org_pro.pauroshoba') }}</b-th>
                <b-td v-if="areaTypeId === 2">{{ hospital.pauroshoba_text }}</b-td>

                <b-th v-if="areaTypeId === 3">{{ $t('org_pro_union.union') }}</b-th>
                <b-td v-if="areaTypeId === 3">{{ hospital.union_text }}</b-td>
              </b-tr>
            </b-table-simple>

          </template>
        </iq-card>
      </b-col>
    </b-row>

    </b-overlay>
  </b-container>
</template>
<script>

import { hospitalServiceBaseUrl } from '@/config/api_config'
import Custom from '../../../../../store/custom'
import ExportPdf from './export-pdf-details'

export default {
  props: ['hospitalId'],
  data () {
    return {
      hospital: null,
      areaTypeId: null,
      load: false
    }
  },
  computed: {
    hospitalCategoryList () {
      const objectData = this.$store.state.HospitalDisabilityService.commonObj.hospitalCategoryList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.id, text: obj.name_bn }
        } else {
          return { value: obj.id, text: obj.name }
        }
      })
    },
    areaTypeList () {
      const objectData = Custom.wardTypeList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.id, text: obj.name_bn }
        } else {
          return { value: obj.id, text: obj.name }
        }
      })
    },
    currentLocale: function () {
      return this.$i18n.locale
    }
  },
  created () {
    if (this.hospitalId) {
      const tmpHospital = this.getHospitalById(this.hospitalId)
      if (tmpHospital === null) {
        this.hospital = {}
      } else {
        /** Valid Hospital Found */
        Object.freeze(tmpHospital)
        this.areaTypeId = parseInt(tmpHospital[0].area_type_id)
        this.hospital = this.getRelationData(tmpHospital)[0]
      }
    }
  },
  methods: {
    getHospitalById (id) {
      const hospital = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.value === id)
      if (hospital.length <= 0) return null
      return JSON.parse(JSON.stringify(hospital))
    },
    getRelationData (data) {
      const listData = data.map(item => {
        // Relational
        const category = this.hospitalCategoryList.find(category => category.value === item.category)
        const areaType = this.areaTypeList.find(area => area.value === item.area_type_id)
        const division = this.$store.state.commonObj.divisionList.find(division => division.value === item.division_id)
        const district = this.$store.state.commonObj.districtList.find(district => district.value === item.district_id)
        const cityCorporation = this.$store.state.commonObj.cityCorporationList.find(cityCorporation => cityCorporation.value === item.city_corporation_id)
        const upazilla = this.$store.state.commonObj.upazilaList.find(upazilla => upazilla.value === item.upazilla_id)
        const union = this.$store.state.commonObj.unionList.find(union => union.value === item.union_id)
        const pauroshoba = this.$store.state.commonObj.pauroshobaList.find(pauroshoba => pauroshoba.value === item.pauroshoba_id)

        // Evaluate
        const evaluationData = {
          id: item.value,
          category_text: category !== undefined ? category.text : '',
          area_type_text: areaType !== undefined ? areaType.text : '',
          division_text: division !== undefined ? division.text : '',
          district_text: district !== undefined ? district.text : '',
          city_corporation_text: (this.areaTypeId === 1 && cityCorporation !== undefined) ? cityCorporation.text : '',
          upazilla_text: (this.areaTypeId >= 2 && upazilla !== undefined) ? upazilla.text : '',
          union_text: (this.areaTypeId === 3 && union !== undefined) ? union.text : '',
          pauroshoba_text: (this.areaTypeId === 2 && pauroshoba !== undefined) ? pauroshoba.text : ''
        }

        // Assign
        return Object.assign({}, item, evaluationData)
      })
      return listData
    },
    async pdfExport () {
      const reportTitle = this.$t('hospital_configuration.hospital_info')
      this.load = true
      await ExportPdf.exportPdfDetails(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, this.hospital, this)
      /** -------------------------------- baseUrl ----------------------------- uri -------------- orgId - reportTitle - hospita --- vm) */
      this.load = false
    }
  }
}
</script>
